import { supabase } from './supabase'

async function rpc(name, args) {
  const { data, error } = await supabase.rpc(name, args)
  if (error) throw new Error(error.message || 'Import history is unavailable.')
  return data
}

// This store deliberately has no dependency on live list/quote/demand stores.
export const assetListImportArchive = {
  begin: source => rpc('asset_list_begin_csv_import', {
    p_list_id: source.listId, p_file_name: source.fileName,
    p_original_base64: source.originalBase64, p_report_date: source.reportDate || null,
    p_import_mode: source.mode,
    p_source_rows: source.rows.map(({ id, symbol, status }) => ({ id, symbol, status: ['invalid', 'duplicate'].includes(status) ? status : 'queued' })),
  }),
  finish: (importId, result) => rpc('asset_list_finish_csv_import', {
    p_import_id: importId, p_outcome: result.outcome,
    p_result_rows: result.rows.map(({ id, symbol, status, instrumentId, message }) => ({ id, symbol, status, instrumentId, message })),
    p_error: result.error,
  }),
}

export async function listAssetListImports(listId, offset = 0) {
  const { data, error } = await supabase.from('asset_list_csv_imports')
    .select('import_id,list_name,file_name,report_date,uploaded_at,import_mode,outcome')
    .eq('list_id', listId).order('uploaded_at', { ascending: false }).order('import_id', { ascending: false })
    .range(offset, offset + 49)
  if (error) throw new Error(error.message || 'Could not load import history.')
  return data || []
}

export async function readAssetListImport(importId) {
  const { data, error } = await supabase.from('asset_list_csv_imports').select('*').eq('import_id', importId).single()
  if (error || !data) throw new Error(error?.message || 'Import record unavailable.')
  return data
}
